import { getAPIClient } from "../helpers";
import type { Event } from "@lemmonhq/types";

export type CreateEventData = Omit<Event, "id" | "restaurant_id">;
export type UpdateEventData = Partial<CreateEventData>;

export const eventsAPI = {
  // GET /events - List all events
  getEvents: async () => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.events.$get({
      query: {},
    });

    if (!resp.ok) {
      throw new Error(`Failed to fetch events: ${resp.status}`);
    }

    return await resp.json();
  },

  // GET /events/:id - Get single event
  getEvent: async (id: string) => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.events[":id"].$get({
      param: { id },
    });

    if (!resp.ok) {
      throw new Error(`Failed to fetch event: ${resp.status}`);
    }

    return await resp.json();
  },

  // POST /events - Create new event
  createEvent: async (data: CreateEventData) => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.events.$post({
      json: data,
    });

    if (!resp.ok) {
      throw new Error(`Failed to create event: ${resp.status}`);
    }

    return await resp.json();
  },

  // PUT /events/:id - Update event
  updateEvent: async (id: string, data: UpdateEventData) => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.events[":id"].$put({
      param: { id },
      json: data,
    });

    if (!resp.ok) {
      throw new Error(`Failed to update event: ${resp.status}`);
    }

    return await resp.json();
  },

  // DELETE /events/:id - Delete event
  deleteEvent: async (id: string) => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.events[":id"].$delete({
      param: { id },
    });

    if (!resp.ok) {
      throw new Error(`Failed to delete event: ${resp.status}`);
    }

    return await resp.json();
  },
};
